import React, { useState } from 'react';
import { useCoupons,useDeleteCoupon } from './coupons.hooks';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  Paper, TableContainer, Typography,
  CircularProgress, Box, Divider, Button,
 Tooltip
} from '@mui/material';
import { constants } from '../../constants';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

import { Link } from 'react-router-dom';
import ModeEditOutlineRoundedIcon from '@mui/icons-material/ModeEditOutlineRounded'
export default function ManageCoupons() {
  const dispatch = useDispatch();
  const deleteMutation = useDeleteCoupon();

  const { data: couponsdata, isLoading,isError,error } = useCoupons();

  if(isError)
  {
    dispatch(
      showAlert({
        severity: constants.ERROR,
        title: error?.response?.data?.message || 'Error fetching coupons.',
      })
    );
  }



  const handleDelete = (id) => {
    if (!window.confirm('Are you sure you want to delete this coupon?')) return;

    deleteMutation.mutate(id, {
      onSuccess: () => {
        dispatch(
          showAlert({
            severity: constants.SUCCESS,
            title: 'Coupon deleted successfully.',
          })
        );
      },
      onError: (err) => {
        dispatch(
          showAlert({
            severity: constants.ERROR,
            title: err?.response?.data?.message || 'Failed to delete coupon.',
          })
        );
      },
    });
  };






  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Manage Coupons
      </Typography>
      <Divider sx={{ my: 2 }} />


      {(isLoading) && (
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={10}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="rgba(255, 255, 255, 0.7)"
      >
        <CircularProgress />
      </Box>
    )}

      {/* Table Section */}
      <TableContainer>
        <Table>
        <TableHead>
  <TableRow>
    <TableCell>ID</TableCell>
    <TableCell>Code</TableCell>
    <TableCell>Type</TableCell>
    <TableCell>Value</TableCell>
    <TableCell>Start Date</TableCell>
    <TableCell>End Date</TableCell>
    <TableCell>Min Purchase</TableCell>
    <TableCell>Status</TableCell>
    <TableCell>Action</TableCell>
  </TableRow>
</TableHead>
<TableBody>
  {couponsdata?.length > 0 ? (
    couponsdata.map((coupon) => (
      <TableRow key={coupon.id}>
        <TableCell>{coupon.id}</TableCell>
        <TableCell>{coupon.code}</TableCell>
        <TableCell>{(coupon.type == constants.COUPEN_TYPE.FIXED)?'Fixed':'Percentage'}</TableCell>
        <TableCell>
          {parseFloat(coupon.value) % 1 === 0
            ? parseInt(coupon.value)
            : coupon.value}
        </TableCell>
        <TableCell>{coupon.start_date}</TableCell>
        <TableCell>{coupon.end_date}</TableCell>
        <TableCell>
          {parseFloat(coupon.minimum_purchase_value) % 1 === 0
            ? parseInt(coupon.minimum_purchase_value)
            : coupon.minimum_purchase_value}
        </TableCell>
        <TableCell>
          {coupon.status === constants.COUPEN_STATUS.ACTIVE ? 'Active' : 'Blocked'}
        </TableCell>
        <TableCell>
        <Link to={`/coupons/add/${coupon.id}`}>
                      <Tooltip title="Edit">
                        <ModeEditOutlineRoundedIcon sx={{ verticalAlign: 'middle', mr: 1, color: 'primary.main' }} />
                      </Tooltip>
                    </Link>
          <Tooltip title="Delete Coupon">
            <Button
              size="small"
              color="error"
              onClick={() => handleDelete(coupon.id)}
              sx={{ minWidth: 0 }}
            >
              <DeleteRoundedIcon />
            </Button>
          </Tooltip>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={9} align="center">
        No records found.
      </TableCell>
    </TableRow>
  )}
</TableBody>

        </Table>
      </TableContainer>



    </Paper>
  );
}
